/* Raised panelling — dynamic preview from window.panelImageConfig (Profile → Width → Height → Image) */
/*
  In theme Liquid, BEFORE this script, set the original product image URL:
  <script>window.panelOriginalProductImageUrl = {{ product.featured_media | image_url: width: 1780 | json }};</script>

  DPO square-metre variant reset: cleared once on load in the cart-guard block below.
  Theme add-to-cart is blocked when DPO options are selected and the form still has the default variant.

  This file does nothing unless DPO option fields are present on the page.
*/

function panelHasDpoOptions() {
  return !!document.querySelector(
    '.dpo-container .options-list, .dpo-container .product-custom-option'
  );
}

function panelRunWhenDpoReady(fn) {
  if (panelHasDpoOptions()) {
    fn();
    return;
  }

  var ran = false;
  function run() {
    if (ran || !panelHasDpoOptions()) return;
    ran = true;
    fn();
  }

  if (document.body) {
    new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
  }
  if (window.jQuery) {
    jQuery(run);
    jQuery(window).one('dpo_loading_finished', run);
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  }
}

(function () {
  panelRunWhenDpoReady(function () {
    if (window.panelOriginalProductImageUrl) return;
  var media =
    document.querySelector('[id^="product-media-"] img.image-detail') ||
    document.querySelector('.product-media-item.featured-image img') ||
    document.querySelector('.product-media-item img') ||
    document.querySelector('.x-splide-slide.featured-image img') ||
    document.querySelector('[id^="x-product-"] img.image-detail');
  if (media) {
    window.panelOriginalProductImageUrl = media.currentSrc || media.src || media.getAttribute('src') || '';
  }
  });
})();

(function () {
  'use strict';

  if (!window.jQuery) return;

  /** Width bands (mm): w1 1–590, w2 591–1180, w3 1181–1770, w4 1771–2360, w5 2361–2950, w6 2951+ */
  var WIDTH_MAX_MM = [590, 1180, 1770, 2360, 2950];
  var WIDTH_KEYS = ['w1', 'w2', 'w3', 'w4', 'w5', 'w6'];
  var WIDTH_LEGACY_ALIASES = { small: 'w2', medium: 'w4', large: 'w6' };

  /** Height bands (mm): unchanged — short < 1180, medium < 1951, tall ≥ 1951 */
  var HEIGHT_THRESHOLDS_MM = { short: 1180, medium: 1951 };
  var HEIGHT_KEYS = ['short', 'medium', 'tall'];

  /**
   * @param {object} raw
   * @returns {object}
   */
  function getProfilesConfig(raw) {
    if (!raw || typeof raw !== 'object') return {};
    if (raw.profiles && typeof raw.profiles === 'object') return raw.profiles;
    return raw;
  }

  /** DPO / variant label → JSON profile key */
  var PROFILE_ALIASES = {
    square: 'square',
    shaker_square: 'square',
    shaker: 'square',
    dchamfer: 'd_chamfer',
    d_chamfer: 'd_chamfer',
    chamfer: 'chamfer',
    beadround: 'bead_round',
    bead_round: 'bead_round',
    beadandround: 'bead_round'
  };

  var PROFILE_LABEL_HINTS = ['profile', 'moulding', 'molding', 'style', 'edge', 'panel'];

  /**
   * @returns {boolean}
   */
  function hasPanelImageConfig() {
    var raw = window.panelImageConfig;
    if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return false;
    if (raw.error) return false;
    var profiles = getProfilesConfig(raw);
    return Object.keys(profiles).length > 0;
  }

  /**
   * @param {string|number} raw
   * @returns {number}
   */
  function parseDimension(raw) {
    var n = parseFloat(String(raw || '').replace(/,/g, ''), 10);
    return isNaN(n) ? 0 : n;
  }

  /**
   * True when DPO cm/mm toggle exists and centimetres is selected.
   * When the cm option is removed, this stays false and values are treated as mm.
   * @returns {boolean}
   */
  function isDpoCmUnitActive() {
    return jQuery('.dpo-container .cm :checked').length > 0;
  }

  /**
   * Read a DPO dimension field and normalise to millimetres (preview bands use mm).
   * @param {string} fieldSelector e.g. '.dpo-cf-width input'
   * @returns {number}
   */
  function readDpoFieldMm(fieldSelector) {
    var n = parseDimension(jQuery(fieldSelector).first().val());
    if (!n) return 0;
    return isDpoCmUnitActive() ? n * 10 : n;
  }

  /**
   * @returns {{ width: number, height: number }}
   */
  function readWallDimensions() {
    return {
      width: readDpoFieldMm('.dpo-cf-width input'),
      height: readDpoFieldMm('.dpo-cf-height input')
    };
  }

  /**
   * @param {number} value wall width from DPO inputs (mm)
   * @returns {'w1'|'w2'|'w3'|'w4'|'w5'|'w6'}
   */
  function widthBucket(value) {
    if (!value || value < 0 || isNaN(value)) return 'w1';
    var i;
    for (i = 0; i < WIDTH_MAX_MM.length; i++) {
      if (value <= WIDTH_MAX_MM[i]) return WIDTH_KEYS[i];
    }
    return 'w6';
  }

  /**
   * @param {number} value wall height from DPO inputs (mm)
   * @returns {'short'|'medium'|'tall'}
   */
  function heightBucket(value) {
    if (!value || value < 0 || isNaN(value)) return 'short';
    if (value < HEIGHT_THRESHOLDS_MM.short) return 'short';
    if (value < HEIGHT_THRESHOLDS_MM.medium) return 'medium';
    return 'tall';
  }

  /**
   * Normalise profile keys to match JSON (square, d_chamfer, chamfer, bead_round).
   * @param {string} raw
   * @returns {string}
   */
  function normalizeProfileKey(raw) {
    if (!raw) return '';
    var key = String(raw)
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '_')
      .replace(/[^a-z0-9_]/g, '');

    if (PROFILE_ALIASES[key]) return PROFILE_ALIASES[key];
    if (key === 'dchamfer') return 'd_chamfer';
    if (key === 'beadround' || key === 'beadandround') return 'bead_round';
    if (key.indexOf('d_chamfer') === 0 || key.indexOf('dchamfer') === 0) return 'd_chamfer';
    if (key.indexOf('bead') === 0 && key.indexOf('round') > 0) return 'bead_round';
    if (key.indexOf('square') >= 0) return 'square';
    if (key === 'chamfer' || key.indexOf('_chamfer') > 0) {
      return key.indexOf('d_') === 0 || key.indexOf('dchamfer') === 0 ? 'd_chamfer' : 'chamfer';
    }
    return key;
  }

  /**
   * Map a candidate string to a key that exists on panelImageConfig.
   * @param {string} candidate
   * @param {object} config
   * @returns {string}
   */
  function resolveProfileKey(candidate, config) {
    if (!candidate || !config) return '';
    config = getProfilesConfig(config);

    var normalized = normalizeProfileKey(candidate);
    if (normalized && config[normalized]) return normalized;

    var alias = PROFILE_ALIASES[normalized];
    if (alias && config[alias]) return alias;

    var keys = Object.keys(config);
    var i;
    for (i = 0; i < keys.length; i++) {
      if (normalized === keys[i]) return keys[i];
    }
    for (i = 0; i < keys.length; i++) {
      if (normalized.indexOf(keys[i]) >= 0 || keys[i].indexOf(normalized) >= 0) {
        return keys[i];
      }
    }
    return '';
  }

  /**
   * Text shown for a checked DPO / variant input.
   * @param {jQuery} $input
   * @returns {string}
   */
  function optionDisplayText($input) {
    var $choice = $input.closest('.choice, .field, .option-value');
    var label = $choice.find('label span, label').first().text();
    if (label) return label;
    if ($input.is('option')) return $input.text();
    return $input.val() || '';
  }

  /**
   * DPO option value id → profile key (set in Liquid: window.panelImageProfileMap).
   * @param {string} valueId
   * @param {object} config
   * @returns {string}
   */
  function profileFromValueMap(valueId, config) {
    var map = window.panelImageProfileMap;
    if (!map || !valueId) return '';
    var mapped = map[valueId] || map[String(valueId)];
    return resolveProfileKey(mapped, config);
  }

  /**
   * Find profile field by label text, then read selection.
   * @param {object} config
   * @returns {string}
   */
  function readProfileFromLabelledField(config) {
    var resolved = '';
    jQuery('.dpo-container .field, form[action="/cart/add"] fieldset').each(function () {
      if (resolved) return;
      var labelText = jQuery(this).find('label, legend').first().text().toLowerCase();
      if (!PROFILE_LABEL_HINTS.some(function (hint) {
        return labelText.indexOf(hint) >= 0;
      })) {
        return;
      }
      var $checked = jQuery(this).find('input[type="radio"]:checked, input[type="checkbox"]:checked');
      if ($checked.length) {
        resolved = resolveProfileKey(optionDisplayText($checked.first()), config);
        if (!resolved) {
          resolved = profileFromValueMap($checked.first().val(), config);
        }
      }
      if (!resolved) {
        var $sel = jQuery(this).find('select');
        if ($sel.length) {
          var $opt = $sel.find('option:selected');
          resolved = resolveProfileKey(optionDisplayText($opt), config);
          if (!resolved) resolved = profileFromValueMap($opt.val(), config);
        }
      }
    });
    return resolved;
  }

  /**
   * Match any checked option label against keys in panelImageConfig.
   * @param {object} config
   * @returns {string}
   */
  function readProfileFromMatchingSelection(config) {
    var resolved = '';
    var $inputs = jQuery(
      '.dpo-container input[type="radio"]:checked, ' +
        '.dpo-container select option:selected, ' +
        'form[action="/cart/add"] input[type="radio"]:checked'
    );

    $inputs.each(function () {
      if (resolved) return;
      var $el = jQuery(this);
      if ($el.closest('.dpo-cf-width, .dpo-cf-height, .cm, .dpo-cf-unit, [class*="dpo-cf-unit"]').length) return;

      var text = optionDisplayText($el);
      resolved = resolveProfileKey(text, config);
      if (!resolved) resolved = profileFromValueMap($el.val(), config);
    });
    return resolved;
  }

  /**
   * @param {object} config
   * @returns {string}
   */
  function readProfileFromDom(config) {
    var $checked = jQuery(
      '.dpo-cf-profile input:checked, ' +
        '.dpo-cf-moulding input:checked, ' +
        '.dpo-cf-style input:checked, ' +
        '[class*="dpo-cf-profile"] input:checked, ' +
        '[class*="dpo-cf-moulding"] input:checked'
    ).first();

    if ($checked.length) {
      var resolved = resolveProfileKey(optionDisplayText($checked), config);
      if (resolved) return resolved;
      resolved = profileFromValueMap($checked.val(), config);
      if (resolved) return resolved;
    }

    var $select = jQuery(
      '.dpo-cf-profile select, .dpo-cf-moulding select, select[name*="profile"], select[name*="moulding"]'
    ).first();
    if ($select.length) {
      var $opt = $select.find('option:selected');
      var fromSelect = resolveProfileKey(optionDisplayText($opt), config);
      if (fromSelect) return fromSelect;
      fromSelect = profileFromValueMap($opt.val(), config);
      if (fromSelect) return fromSelect;
    }

    return (
      readProfileFromLabelledField(config) ||
      readProfileFromMatchingSelection(config) ||
      ''
    );
  }

  /**
   * Shopify variant option (Eurus picker) when profile is a native option.
   * @param {object} config
   * @returns {string}
   */
  function readProfileFromShopifyVariant(config) {
    var resolved = '';
    jQuery('form[action="/cart/add"] [data-option-name]').each(function () {
      if (resolved) return;
      var optName = String(jQuery(this).data('option-name') || '').toLowerCase();
      if (!PROFILE_LABEL_HINTS.some(function (hint) {
        return optName.indexOf(hint) >= 0;
      })) {
        return;
      }
      var text =
        jQuery(this).find('.option-selected-value span').text() ||
        jQuery(this).find('input:checked + label, input:checked ~ label').text() ||
        jQuery(this).find('[aria-checked="true"]').text();
      resolved = resolveProfileKey(text, config);
    });
    return resolved;
  }

  /**
   * @param {object} [config]
   * @returns {string}
   */
  function getProfileKey(config) {
    var raw = config || window.panelImageConfig;
    var profiles = getProfilesConfig(raw);
    return (
      readProfileFromShopifyVariant(raw) ||
      readProfileFromDom(raw) ||
      resolveProfileKey(window.panelImageDefaultProfile, raw) ||
      (profiles.square ? 'square' : Object.keys(profiles)[0] || 'square')
    );
  }

  /**
   * Leaf may be a URL string or metaobject shape { image: "..." }.
   * @param {*} entry
   * @returns {string|null}
   */
  function extractImageUrl(entry) {
    if (!entry) return null;
    if (typeof entry === 'string') return entry;
    if (typeof entry === 'object') {
      return entry.image || entry.url || entry.src || null;
    }
    return null;
  }

  /**
   * Lookup: config[profile][widthKey][heightKey]
   * @param {object} config
   * @param {string} profile
   * @param {string} widthKey
   * @param {string} heightKey
   * @returns {string|null}
   */
  function lookupPanelImage(config, profile, widthKey, heightKey) {
    config = getProfilesConfig(config);
    if (!config || typeof config !== 'object') return null;

    var profileNode = config[profile];
    if (!profileNode) return null;

    var widthNode = profileNode[widthKey];
    if (!widthNode && WIDTH_LEGACY_ALIASES[widthKey]) {
      widthNode = profileNode[WIDTH_LEGACY_ALIASES[widthKey]];
    }
    if (!widthNode) return null;

    return extractImageUrl(widthNode[heightKey]);
  }

  /**
   * Resolve preview URL from window.panelImageConfig.
   * @param {object} [opts]
   * @param {object} [opts.config]
   * @param {string} [opts.profile]
   * @param {number} [opts.width]
   * @param {number} [opts.height]
   * @returns {string|null}
   */
  function getPanelImageUrl(opts) {
    opts = opts || {};
    if (!hasPanelImageConfig()) return null;

    var rawConfig = opts.config || window.panelImageConfig;
    var profiles = getProfilesConfig(rawConfig);
    var dims = readWallDimensions();
    var widthVal = opts.width != null ? opts.width : dims.width;
    var heightVal = opts.height != null ? opts.height : dims.height;
    var profile = resolveProfileKey(opts.profile, rawConfig) || getProfileKey(rawConfig);
    var wKey = widthBucket(widthVal);
    var hKey = heightBucket(heightVal);

    var url = lookupPanelImage(profiles, profile, wKey, hKey);

    /* fallback: same profile, any width bucket for this height */
    if (!url && profiles[profile]) {
      var i;
      for (i = 0; i < WIDTH_KEYS.length; i++) {
        url = lookupPanelImage(profiles, profile, WIDTH_KEYS[i], hKey);
        if (url) break;
      }
    }

    return url;
  }

  var panelOverlayReady = false;
  var lastPanelPreviewUrl = null;
  var galleryReadyBound = {};

  /**
   * @returns {jQuery}
   */
  function getProductMediaRoot() {
    return jQuery('[id^="product-media-"]').first();
  }

  /**
   * Unique Shopify media ids rendered in the gallery (ignores splide loop clones).
   * @returns {string[]}
   */
  function getUniqueProductMediaIds() {
    var ids = [];
    var seen = {};
    getProductMediaRoot().find('[data-media-id]').each(function () {
      var id = jQuery(this).attr('data-media-id');
      if (id && !seen[id]) {
        seen[id] = true;
        ids.push(id);
      }
    });
    return ids;
  }

  /**
   * Featured / primary media id for panel preview.
   * @returns {string}
   */
  function getPrimaryMediaId() {
    var $root = getProductMediaRoot();
    var $featured = $root.find('.featured-image[data-media-id]').first();
    if ($featured.length) return $featured.attr('data-media-id') || '';

    var ids = getUniqueProductMediaIds();
    return ids[0] || '';
  }

  /**
   * All img nodes for one media id (stacked + slider + splide clones + thumbnail).
   * @param {string} mediaId
   * @returns {jQuery}
   */
  function getImagesForMediaId(mediaId) {
    if (!mediaId) return jQuery();
    return jQuery('[data-media-id]')
      .filter(function () {
        return jQuery(this).attr('data-media-id') === mediaId;
      })
      .find('img')
      .not('.panel-original-image-overlay img');
  }

  /**
   * Images to swap for the panel preview.
   * @returns {jQuery}
   */
  function getPanelPreviewTargetImages() {
    var mediaIds = getUniqueProductMediaIds();
    var primaryId = getPrimaryMediaId();
    var $imgs = jQuery();

    if (primaryId) {
      $imgs = getImagesForMediaId(primaryId);
    }

    /* Single product media — also hit every image-detail in gallery (magnifier, etc.) */
    if (mediaIds.length <= 1) {
      if (!$imgs.length) {
        $imgs = getProductMediaRoot().find('img.image-detail').not('.panel-original-image-overlay img');
      }
      if (!$imgs.length) {
        $imgs = jQuery('[id^="product-image-"] img').not('.panel-original-image-overlay img');
      }
      if (!$imgs.length) {
        $imgs = jQuery('.product-media-item img').not('.panel-original-image-overlay img');
      }
      if (!$imgs.length) {
        $imgs = jQuery('[id^="x-product-"] img.image-detail').not('.panel-original-image-overlay img');
      }
      return $imgs;
    }

    /* Multi-image carousel — featured media only */
    if (!$imgs.length) {
      $imgs = getProductMediaRoot().find('.featured-image img.image-detail').not('.panel-original-image-overlay img');
    }
    if (!$imgs.length) {
      $imgs = jQuery('[id^="x-product-"] .featured-image img.image-detail').not('.panel-original-image-overlay img');
    }

    return $imgs;
  }

  function reapplyPanelPreviewIfNeeded() {
    if (!panelPreviewEnabled || !lastPanelPreviewUrl) return;
    getPanelPreviewTargetImages().attr({ src: lastPanelPreviewUrl, srcset: lastPanelPreviewUrl });
  }

  function bindGalleryReadyEvents() {
    jQuery('[id^="x-product-"]').each(function () {
      var sectionId = this.id.replace('x-product-', '');
      if (galleryReadyBound[sectionId]) return;
      galleryReadyBound[sectionId] = true;
      document.addEventListener('eurus:media-gallery-ready:' + sectionId, function () {
        if (panelPreviewEnabled && lastPanelPreviewUrl) {
          setProductMediaImage(lastPanelPreviewUrl);
        }
      });
    });
  }

  function bindCarouselPreviewHandlers() {
    bindGalleryReadyEvents();

    jQuery(document).on(
      'click',
      '.splide__arrow, .x-thumbnail, .media-thumbnail, [id^="x-product-"] .splide__pagination button',
      function () {
        window.setTimeout(reapplyPanelPreviewIfNeeded, 120);
      }
    );
  }

  function injectOriginalOverlayStyles() {
    if (document.getElementById('panel-original-overlay-styles')) return;

    var css =
      '.panel-original-image-overlay{' +
      'position:absolute;top:8px;right:8px;z-index:25;width:72px;height:72px;' +
      'border-radius:6px;overflow:hidden;box-shadow:0 2px 10px rgba(0,0,0,.22);' +
      'border:2px solid #fff;background:#fff;pointer-events:none}' +
      '.panel-original-image-overlay img{width:100%;height:100%;object-fit:cover;display:block}' +
      '@media (min-width:768px){.panel-original-image-overlay{width:96px;height:96px;top:12px;right:12px}}';

    jQuery('<style id="panel-original-overlay-styles">' + css + '</style>').appendTo('head');
  }

  function ensureOriginalImageOverlay() {
    if (panelOverlayReady) return;

    var url = window.panelOriginalProductImageUrl;
    if (!url) return;

    var $mount = jQuery('[id^="product-media-"]').first();
    if (!$mount.length) return;

    injectOriginalOverlayStyles();

    if ($mount.css('position') === 'static') {
      $mount.css('position', 'relative');
    }

    if (!$mount.children('.panel-original-image-overlay').length) {
      var $overlay = jQuery(
        '<div class="panel-original-image-overlay" title="Original product image" aria-label="Original product image">' +
          '<img alt="" />' +
        '</div>'
      );
      $overlay.find('img').attr({ src: url, srcset: url });
      $mount.append($overlay);
    }

    panelOverlayReady = true;
  }

  /**
   * @param {string|null} url
   */
  function setProductMediaImage(url) {
    if (!url) return;
    lastPanelPreviewUrl = url;

    var $targets = getPanelPreviewTargetImages();
    if ($targets.length) {
      $targets.attr({ src: url, srcset: url });
      return;
    }

    /* Gallery may not be in DOM yet — retries help single-image stacked / splide init */
    var delays = [100, 300, 600, 1200];
    var i;
    for (i = 0; i < delays.length; i++) {
      (function (delay) {
        window.setTimeout(function () {
          if (lastPanelPreviewUrl !== url) return;
          getPanelPreviewTargetImages().attr({ src: url, srcset: url });
        }, delay);
      })(delays[i]);
    }
  }

  function refreshPanelPreview() {
    if (!hasPanelImageConfig()) return;
    if (window.panelImageDebug) {
      var cfg = window.panelImageConfig;
      console.log(
        '[panelImage] profile:', getProfileKey(cfg),
        'mediaIds:', getUniqueProductMediaIds(),
        'primaryId:', getPrimaryMediaId(),
        'targets:', getPanelPreviewTargetImages().length
      );
    }
    setProductMediaImage(getPanelImageUrl());
  }

  var featureWallHeadingBound = false;

  /* Off until the customer changes an option (avoids load + default DPO price calc) */
  var panelPreviewEnabled = false;

  function enablePanelPreview() {
    panelPreviewEnabled = true;
  }

  /**
   * Show "Feature Wall Configurator Only" above product images when DPO is present.
   * @returns {boolean}
   */
  function ensureFeatureWallConfiguratorHeading() {
    if (!jQuery('.dpo-container .options-list, .dpo-container .product-custom-option').length) {
      return false;
    }
    if (document.querySelector('.panel-feature-wall-heading')) return true;

    var $mount = jQuery('.product-media-container').first();
    if (!$mount.length) $mount = getProductMediaRoot();
    if (!$mount.length) return false;

    jQuery(
      '<h3 class="panel-feature-wall-heading mb-4 md:mb-5">Feature Wall Configurator Only</h3>'
    ).prependTo($mount);
    return true;
  }

  function bindFeatureWallConfiguratorHeading() {
    if (featureWallHeadingBound) return;
    featureWallHeadingBound = true;

    ensureFeatureWallConfiguratorHeading();

    var observer = new MutationObserver(function () {
      if (ensureFeatureWallConfiguratorHeading()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    jQuery(window).on('dpo_loading_finished', ensureFeatureWallConfiguratorHeading);
  }

  jQuery(panelRunWhenDpoReady.bind(null, function () {
    bindFeatureWallConfiguratorHeading();
    jQuery(window).on('load', ensureFeatureWallConfiguratorHeading);

    if (!hasPanelImageConfig()) return;

    jQuery(function () {
      bindCarouselPreviewHandlers();
      ensureOriginalImageOverlay();
    });
    jQuery(window).on('load', function () {
      bindGalleryReadyEvents();
      if (panelPreviewEnabled && lastPanelPreviewUrl) {
        setProductMediaImage(lastPanelPreviewUrl);
      }
    });

    window.getPanelImageUrl = getPanelImageUrl;
    window.refreshPanelPreview = refreshPanelPreview;

    jQuery(document).on('change', '.dpo-container', enablePanelPreview);

    jQuery(window).on('dpoPriceUpdate', function () {
      if (!panelPreviewEnabled) return;
      window.setTimeout(function () {
        try {
          refreshPanelPreview();
        } catch (err) {
          if (window.panelImageDebug) console.warn('[panelImage] preview error:', err);
        }
      }, 150);
    });
  }));
})();

/*
 * Block theme "simple product" add-to-cart when the customer has configured DPO options.
 * Only runs on pages where DPO option fields exist, scoped to that product block.
 */
(function () {
  'use strict';

  if (!window.jQuery) return;

  var dpoProductScope = null;
  var dpoOptionsSelected = false;
  var defaultSimpleVariantIds = null;

  function getDpoProductScope() {
    if (!panelHasDpoOptions()) return null;
    if (dpoProductScope && dpoProductScope.isConnected) return dpoProductScope;

    var dpoContainer = document.querySelector('.dpo-container');
    if (!dpoContainer) return null;

    var scope = dpoContainer.closest('.product-info');
    if (!scope) return null;

    dpoProductScope = scope;
    return scope;
  }

  function captureDefaultVariantIds() {
    var scope = getDpoProductScope();
    if (!scope) return {};

    if (defaultSimpleVariantIds) return defaultSimpleVariantIds;

    defaultSimpleVariantIds = {};
    jQuery(scope)
      .find('input[name="id"][id^="update-variant-"]:not([id*="template"])')
      .each(function () {
        if (this.value) {
          defaultSimpleVariantIds[this.id || 'id'] = String(this.value);
        }
      });
    return defaultSimpleVariantIds;
  }

  function clearDpoTemplateVariantOnceOnLoad() {
    if (window.__dpoTemplateVariantClearedOnLoad) return;

    var scope = getDpoProductScope();
    if (!scope) return;

    var dpoVariantInput = scope.querySelector(
      '#update-variant-template--25441307492619__main, input[id*="update-variant-template"]'
    );
    if (!dpoVariantInput) return;

    dpoVariantInput.value = '';
    window.__dpoTemplateVariantClearedOnLoad = true;
  }

  function isThemeVariantStillDefault() {
    var scope = getDpoProductScope();
    if (!scope) return false;

    var defaults = captureDefaultVariantIds();
    var keys = Object.keys(defaults);
    if (!keys.length) return false;

    var stillDefault = false;
    jQuery(scope)
      .find('input[name="id"][id^="update-variant-"]:not([id*="template"])')
      .each(function () {
        var key = this.id || 'id';
        if (defaults[key] && String(this.value) === defaults[key]) {
          stillDefault = true;
        }
      });
    return stillDefault;
  }

  function isDpoAtcButton(btn) {
    if (!btn || btn.nodeType !== 1) return false;
    if (btn.getAttribute('dpo_add2cart') === '1') return true;
    var onclick = btn.getAttribute('onclick') || '';
    return onclick.indexOf('dpoOptions.addToCart') !== -1;
  }

  function getThemeAtcButtons() {
    var scope = getDpoProductScope();
    if (!scope) return jQuery();

    return jQuery(scope).find('.add_to_cart_button').filter(function () {
      return !isDpoAtcButton(this);
    });
  }

  function shouldBlockThemeAtc() {
    if (!getDpoProductScope()) return false;
    if (!dpoOptionsSelected) return false;
    return isThemeVariantStillDefault();
  }

  function updateThemeAtcGuard() {
    var block = shouldBlockThemeAtc();
    getThemeAtcButtons().each(function () {
      if (block) {
        this.setAttribute('disabled', 'disabled');
        this.setAttribute('aria-disabled', 'true');
        this.classList.add('panel-dpo-theme-atc-blocked');
      } else if (this.classList.contains('panel-dpo-theme-atc-blocked')) {
        this.removeAttribute('disabled');
        this.setAttribute('aria-disabled', 'false');
        this.classList.remove('panel-dpo-theme-atc-blocked');
      }
    });
  }

  function markDpoOptionsSelected() {
    if (!getDpoProductScope()) return;
    dpoOptionsSelected = true;
    updateThemeAtcGuard();
  }

  function initCartGuard() {
    var scope = getDpoProductScope();
    if (!scope) return;

    captureDefaultVariantIds();
    clearDpoTemplateVariantOnceOnLoad();

    var dpoContainer = scope.querySelector('.dpo-container');
    if (dpoContainer) {
      jQuery(dpoContainer).on('change input', markDpoOptionsSelected);
    }

    jQuery(window).on('dpoPriceUpdate', function () {
      if (!getDpoProductScope()) return;
      window.setTimeout(updateThemeAtcGuard, 100);
    });
    jQuery(window).on('dpo_loading_finished', function () {
      if (!getDpoProductScope()) return;
      defaultSimpleVariantIds = null;
      captureDefaultVariantIds();
      updateThemeAtcGuard();
    });

    jQuery(scope).on('submit', 'form[action="/cart/add"]', function (e) {
      if (!shouldBlockThemeAtc()) return;
      e.preventDefault();
      e.stopPropagation();
      return false;
    });

    scope.addEventListener(
      'click',
      function (e) {
        if (!shouldBlockThemeAtc()) return;
        var btn = e.target && e.target.closest ? e.target.closest('.add_to_cart_button') : null;
        if (!btn || !scope.contains(btn) || isDpoAtcButton(btn)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
      },
      true
    );

    updateThemeAtcGuard();
  }

  panelRunWhenDpoReady(initCartGuard);
})();

/* RP: connect the app's existing labels; leave validation and pricing untouched. */
(function () {
  'use strict';
  if (window.rpDpoLabelsInstalled) return;
  window.rpDpoLabelsInstalled = true;
  var queued = false;
  function connectLabels() {
    queued = false;
    document.querySelectorAll('.dpo-container .field > .control input.product-custom-option, .dpo-container .field > .control select.product-custom-option, .dpo-container .field > .control textarea.product-custom-option').forEach(function (input) {
      if (!input.id || input.type === 'hidden' || input.type === 'radio' || input.type === 'checkbox') return;
      var field = input.closest('.field');
      var label = field && field.querySelector(':scope > label');
      if (label && !input.labels.length) label.setAttribute('for', input.id);
      if (input.classList.contains('validate-digits') && !input.hasAttribute('inputmode')) input.setAttribute('inputmode', 'numeric');
      if (label && label.classList.contains('required') && !input.hasAttribute('aria-required')) input.setAttribute('aria-required', 'true');
    });
  }
  function scheduleLabels() {
    if (!queued) { queued = true; window.requestAnimationFrame(connectLabels); }
  }
  function start() {
    connectLabels();
    new MutationObserver(function (records) {
      if (records.some(function (record) {
        return record.target.nodeType === 1 && record.target.closest('.dpo-container') || Array.from(record.addedNodes).some(function (node) {
          return node.nodeType === 1 && (node.matches('.dpo-container') || node.querySelector('.dpo-container'));
        });
      })) scheduleLabels();
    }).observe(document.body, { childList: true, subtree: true });
    if (window.jQuery) window.jQuery(window).on('dpo_loading_finished.rpLabels', scheduleLabels);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
